import type { DefaultOptionType } from "antd/es/select"

export const OTHER_TOP_LEVEL_CATEGORY = "Other"

export const OTHER_TOP_LEVEL_OPTIONS: DefaultOptionType[] = [
	{ label: OTHER_TOP_LEVEL_CATEGORY, value: OTHER_TOP_LEVEL_CATEGORY },
]
